import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { Button } from 'shared/components/Button';
import { Modal } from 'shared/components/Modal';
import { variableFontRegular } from 'styles/theme';

export interface IChangeShoppingRegionModal {
  body: string;
  onCloseModal: () => void;
  onChangeRegionClick: () => void;
}

export const ChangeShoppingRegionModal = ({
  body,
  onCloseModal,
  onChangeRegionClick,
}: IChangeShoppingRegionModal) => {
  const { t } = useTranslation();

  return (
    <ChangeShoppingRegionModal.Modal onClose={onCloseModal} title="" data-qa="global_pricing_modal">
      <ChangeShoppingRegionModal.ModalText data-qa="global_pricing_modal_body">
        {body}
      </ChangeShoppingRegionModal.ModalText>
      <ChangeShoppingRegionModal.Button
        onClick={onCloseModal}
        data-qa="global_pricing_modal_confirm_button"
      >
        {t('productTemplate.globalPricingModalOkButton', 'Okay')}
      </ChangeShoppingRegionModal.Button>
      <ChangeShoppingRegionModal.ChangeRegionButton
        onClick={onChangeRegionClick}
        data-qa="global_pricing_modal_change_region_button"
      >
        {t('productTemplate.globalPricingModalChangeRegion', 'Change my region')}
      </ChangeShoppingRegionModal.ChangeRegionButton>
    </ChangeShoppingRegionModal.Modal>
  );
};

ChangeShoppingRegionModal.Modal = styled(Modal)`
  max-width: 335px;
`;

ChangeShoppingRegionModal.ModalText = styled.p`
  margin: 8px 0 32px;
  ${variableFontRegular({ size: '9.5px', height: '12px' })};
`;

ChangeShoppingRegionModal.Button = styled(Button)`
  width: 100%;
  ${variableFontRegular({ size: '9.5px', height: '12px' })};
  text-transform: uppercase;
`;

ChangeShoppingRegionModal.ChangeRegionButton = styled.button`
  ${variableFontRegular({ size: '11.5px', height: '14px' })};
  margin-top: 16px;
  text-transform: capitalize;
  text-decoration: underline;
`;
